var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit Square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M9.35367 1.03711H5.78076C2.84236 1.03711 1 3.11367 1 6.05348V13.9839C1 16.9237 2.83376 19.0003 5.78076 19.0003H14.2128C17.1607 19.0003 18.9945 16.9237 18.9945 13.9839V10.1417",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80758 8.79355L13.9486 1.66532C14.8383 0.778226 16.2802 0.778226 17.1699 1.66532L18.3328 2.82617C19.2225 3.71422 19.2225 5.15456 18.3328 6.04165L11.1574 13.2042C10.7685 13.5924 10.241 13.8109 9.69056 13.8109H6.11096L6.20079 10.2053C6.21416 9.67492 6.43108 9.16937 6.80758 8.79355Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M12.8634 2.7666L17.2266 7.12195",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailicon);
export default __webpack_public_path__ + "static/media/emailicon.bf0434762f84abad3fc0c2cb6301d3d3.svg";
export { ForwardRef as ReactComponent };